import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

export default function Auth0ProviderWithNavigate({ children }) {
  // const navigate = useNavigate();

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_AUTH0_CALLBACK_URL;

  Auth0ProviderWithNavigate.propTypes = {
    children: PropTypes.any
  };

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  // console.log(domain);
  // console.log(clientId);
  // console.log(redirectUri)

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      cacheLocation={'localstorage'}
      useRefreshTokens={true}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: "openid profile email offline_access" // Make sure offline_access is here!
      }}
    // onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};